import { Table } from "antd";

const TemperatureAlertTable = ({
  tableData,
  paginationDetails,
  updatePaginationDetails,
}) => {
  const handlePageChange = (pagination) => {
    updatePaginationDetails({
      ...paginationDetails,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  const columns = [
    {
      title: "IMEI",
      dataIndex: "imei",
      key: "imei",
      className: "pl1",
    },
    {
      title: "Peak Temperature",
      dataIndex: "maxTempMax",
      key: "maxTempMax",
    },
    {
      title: "Avg Temperature",
      dataIndex: "avgTempMax",
      key: "avgTempMax",
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
    },
  ];

  return (
    <Table
      data-testid="battery-temp-alerts"
      columns={columns}
      dataSource={tableData.List}
      rowKey={(record) => record.testId}
      loading={tableData.loading}
      scroll={{ x: "100%" }}
      onChange={handlePageChange}
      className="battery-temp-alerts-table"
      pagination={{
        current: paginationDetails.current,
        pageSize: paginationDetails.pageSize,
        total: tableData.totalElements,
        showSizeChanger: false,
        showQuickJumper: false,
        hideOnSinglePage: true,
      }}
    />
  )
};
export default TemperatureAlertTable;